/* eslint-disable @typescript-eslint/no-explicit-any */
export const objectToFormData = (object: any) => {
  const formData = new FormData();
  for (const key in object) {
    formData.append(key, object[key]);
  }
  return formData;
};
